<template>
  <v-card v-if="item">
    <div
      class="separator"
      v-if="subItems.length > 0">
      {{ $t('components.relevantSidebar.functionInContainer', 'In this container') }}
    </div>
    <transition-group
      name="item"
      tag="div">
      <RelevantItem
        v-for="subItem in subItems"
        :key="subItem.id"
        :item="subItem"
        :selected="subItem === item"
        @click.native="navigateToItem(subItem)" />
      <div
        class="separator"
        v-if="relevantItems.length > 0"
        key="separator">
        {{ $t('components.relevantSidebar.mayInterestYou', 'May interest you') }}
      </div>
      <RelevantItem
        v-for="subItem in relevantItems"
        :key="subItem.id"
        :item="subItem"
        @click.native="navigateToItem(subItem)" />
    </transition-group>
  </v-card>
</template>

<script>
import { orderItems, isContainerFilter } from '../../helpers/search'
import { mapState, mapActions } from 'vuex'
import { uniq, differenceWith, reduce } from 'lodash'
import RelevantItem from './RelevantItem'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('search', [
      'index',
      'keywords'
    ]),
    currentContainer () { // container contains current item
      return this.item && this.item.getContainer()
    },
    subItems () { // get items in current container
      return this.currentContainer ? orderItems(this.currentContainer.items.filter(this.filterItem)) : []
    },
    relatedKeywords () {
      return this.item && this.keywords.filter(k => ~k.items.indexOf(this.item.id))
    },
    keywordsItems () { // items of each keyword contains in current item
      return this.item
        ? uniq(reduce(this.relatedKeywords.map(k => k.items), (flattened, other) => {
          return flattened.concat(other)
        }, []).map(id => this.index[id]).filter(this.filterItem)) : []
    },
    relevantItems () {
      return orderItems(differenceWith(this.keywordsItems, this.subItems))
    }
  },
  methods: {
    ...mapActions('search', [
      'navigateToItem'
    ]),
    filterItem (item) {
      return item && !isContainerFilter(item)
    }
  },
  components: {
    RelevantItem
  }
}

</script>

<style lang="scss" scoped>
  .separator {
    border-bottom:1px solid #eeeeee;
    padding-bottom: 8px;
    margin-bottom: 16px;
  }

  .item {
    &-move {
      transition: all 600ms ease-in-out 50ms
    }
    &-enter-active {
      transition: all 300ms ease-out
    }

    &-leave-active {
      transition: all 200ms ease-in;
      position: absolute;
      z-index: 0;
    }

    &-enter,
    &-leave-to {
      opacity: 0
    }
    &-enter {
      transform: scale(0.9)
    }
  }
</style>
